import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment-timezone';

import TextInput from '../textinput';

import { groupItemsBy } from '../../services/utils';
import { omitEmptyProps } from '../../services/helpers';
import { Intents } from '../../constants/order';
import { ContractTypes } from '../../constants/contract';

import 'react-day-picker/lib/style.css';

const CONTRACT_TYPES = [ContractTypes.OTC, ContractTypes.CME, ContractTypes.PHYSICAL];
const DEFAULT_PAGE_SIZE = 200;

const TransactionsLogFilters = ({ filterLogs, markets, products, pageSizes }) => {
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [search, setSearch] = useState('');
    const [orderId, setOrderId] = useState('');
    const [productId, setProductId] = useState('');
    const [intent, setIntent] = useState('');
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

    const onInputChange = e => {
        setSearch(e.target.value);
    };

    const onIntentChange = e => {
        setIntent(e.target.value);
    };
    const onOrderIdChange = e => {
        setOrderId(e.target.value);
    };

    const onProductChange = e => {
        setProductId(e.target.value);
    };

    const onPageSizeChange = e => {
        setPageSize(e.target.value);
    };

    const onClear = e => {
        e.preventDefault();

        setDateFrom('');
        setDateTo('');
        setProductId('');
        setSearch('');
        setOrderId('');
        setPageSize(DEFAULT_PAGE_SIZE);
        setIntent('');

        filterLogs({ pageSize: DEFAULT_PAGE_SIZE });
    };

    const onSearch = e => {
        e.preventDefault();

        const product = products.find(p => p.id === +productId);
        const filters = omitEmptyProps({
            dateFrom: dateFrom ? moment(dateFrom).startOf('day').toISOString() : null,
            dateTo: dateTo ? moment(dateTo).endOf('day').toISOString() : null,
            search,
            product: product ? product.name : null,
            intent,
            pageSize,
            orderId,
        });

        filterLogs(filters);
    };

    return (
        <form className="systemlog-filters">
            <div className="filters-container">
                <div className="input-container field-wrap">
                    <label className="active">Date From</label>
                    <DayPickerInput onDayChange={setDateFrom} value={dateFrom} format="YYYY-MM-DD" />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Date To</label>
                    <DayPickerInput onDayChange={setDateTo} value={dateTo} format="YYYY-MM-DD" />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Order ID</label>
                    <TextInput showLabel={false} name="order_id" value={orderId} onChange={onOrderIdChange} />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Creator name or email</label>
                    <TextInput showLabel={false} name="search" value={search} onChange={onInputChange} />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Product</label>
                    <Scroll.Element name="product_id" />
                    <select name="product_id" onChange={onProductChange} value={productId}>
                        <option>None</option>
                        {markets.map((market, i) => {
                            const marketProducts = products.filter(p => p.market_id === market.id);
                            const groups = groupItemsBy(marketProducts, 'contract_type');
                            const contracts = CONTRACT_TYPES.filter(contract_type => !!groups[contract_type]);

                            return contracts.map(contract_type => (
                                <optgroup
                                    label={`${market.name} - ${contract_type}`}
                                    key={`markgr${i}${contract_type}`}
                                >
                                    {groups[contract_type].map((product, j) => (
                                        <option value={product.id} key={`prod${j}`}>
                                            {product.short_name} ({product.unit_name}, {product.contract_type})
                                        </option>
                                    ))}
                                </optgroup>
                            ));
                        })}
                    </select>
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Intent</label>
                    <Scroll.Element name="intent" />
                    <select name="product_id" onChange={onIntentChange} value={intent}>
                        <option>None</option>
                        <option>{Intents.BUY}</option>
                        <option>{Intents.SELL}</option>
                    </select>
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Page size</label>
                    <Scroll.Element name="intent" />
                    <select name="product_id" onChange={onPageSizeChange} value={pageSize}>
                        {pageSizes.map(size => (
                            <option key={size}>{size}</option>
                        ))}
                    </select>
                </div>
            </div>
            <button type="submit" className="button" onClick={onClear}>
                Clear filters
            </button>
            <button type="submit" className="button" onClick={onSearch}>
                Search
            </button>
        </form>
    );
};

TransactionsLogFilters.propTypes = {
    filterLogs: PropTypes.func.isRequired,
    pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
    markets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default TransactionsLogFilters;



// WEBPACK FOOTER //
// ./source/components/systemLogs/transactionLogsFilters.js